/**
 * Color utility functions for the graph explorer
 */

/**
 * The API returns colors as three decimal numbers between 0 and 255 for rgb values.
 * This function converts them to hex color strings.
 *
 * @example
 * colorFromApiColor('0:0:0') // => '#000000'
 * colorFromApiColor('255:255:255') // => '#ffffff'
 */
export function colorFromApiColor(color: string): string {
  return (
    '#' +
    color
      .split(':')
      .map((s) => ('00' + parseInt(s).toString(16)).slice(-2))
      .join('')
  )
}

/**
 * Darkens a hex color by 20%
 */
export function darkenFillColor(fillColor: string): string {
  if (!fillColor || !fillColor.startsWith('#')) return fillColor
  if (fillColor.length === 4) {
    fillColor =
      '#' + fillColor[1] + fillColor[1] + fillColor[2] + fillColor[2] + fillColor[3] + fillColor[3]
  }
  fillColor = fillColor.toLowerCase()

  const color = parseInt(fillColor.slice(1), 16)
  let r = (color >> 16) & 255
  let g = (color >> 8) & 255
  let b = color & 255

  r = Math.floor(r * 0.8)
  g = Math.floor(g * 0.8)
  b = Math.floor(b * 0.8)
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`
}
